<template>
  <div>
    <h5>Данные ребенка</h5>
    <div class="row d-flex flex-wrap flex-column flex-sm-row">
      <div class="form-group col col-md-3 required">
        <component-input
          placeholder="Введите фамилию"
          label="Фамилия"
          required
          :maxLength="50"
          v-model="item.surname"
        />
      </div>

      <div class="form-group col col-md-3 required">
        <component-input
          placeholder="Введите имя"
          label="Имя"
          required
          :maxLength="50"
          v-model="item.name"
        />
      </div>

      <div class="form-group col col-md-3">
        <component-input
          placeholder="Введите отчество"
          label="Отчество"
          :maxLength="50"
          v-model="item.patronimic"
        />
      </div>

      <div class="form-group col col-md-3 required">
        <label class="control-label">Дата рождения</label>
        <div>
          <date-component
            :disabled="false"
            v-model="item.dateOfBirth"
            required
            :notFuture="true"
          />
        </div>
      </div>
    </div>
    <div class="row pb-2">
      <div class="form-group col col-md-3 required">
        <component-input
          label="Район"
          type="select2"
          required
          :select2Options="districtList"
          :select2Settings="select2Settings"
          v-model="item.addressDistrictId"
        />
      </div>
      <div class="form-group col col-md-9 required">
        <component-input
          placeholder="Введите адрес"
          label="Адрес"
          :maxLength="500"
          v-model="item.address"
          required
        />
      </div>
    </div>
    <div class="row mb-4 border-bottom pb-2">
      <div class="form-group col col-9">
        <label class="control-label"
          >Наименование мед. организации прикрепления</label
        >
        <Select2Ajax
          id="med-org-select"
          v-model="item.medOrgId"
          :key="medOrgKey"
          url="/api/organizations/Suggest?kindActivityId=1"
          :options="{ text: item.medOrgName, forceSelect: true }"
          placeholder="Введите наименование мед. организации прикрепления"
          :disabled="item.imported"
        />
      </div>
      <div class="form-group col col-3">
        <button-component
          v-show="id > 0"
          class="justify-content-center btn-qr-code mt-3"
          @click="updateFromRMIS" :disabled="isUpdateFromRMIS"
          ><i class="fa fa-spinner fa-spin mr-2" v-if="isUpdateFromRMIS"> </i>Обновить данные из ЕЦП
        </button-component>
      </div>
    </div>

    <h5>Законный представитель</h5>
    <div v-for="(repres, index) in item.tmpRepresentatives" :key="repres.id">
      <button-component
        class="btn mb-4"
        kind="secondary"
        v-if="index > 0"
        v-on:click="deleteRepres(repres)"
      >
        Удалить
      </button-component>
      <div class="row flex-wrap flex-column flex-sm-row">
        <div class="form-group col col-md-3 required">
          <component-input
            placeholder="Введите фамилию"
            label="Фамилия"
            required
            :maxLength="50"
            v-model="repres.surname"
          />
        </div>

        <div class="form-group col col-md-3 required">
          <component-input
            placeholder="Введите имя"
            label="Имя"
            required
            :maxLength="50"
            v-model="repres.name"
          />
        </div>

        <div class="form-group col col-md-3">
          <component-input
            placeholder="Введите отчество"
            label="Отчество"
            :maxLength="50"
            v-model="repres.patronimic"
          />
        </div>
      </div>
      <div class="row border-bottom mb-4">
        <div class="form-group col col-md-3 select2 required mb-4">
          <component-input
            label="Степень родства"
            type="select2"
            required
            :select2Options="relationTypeList"
            :select2Settings="select2Settings"
            v-model="repres.relationTypeId"
          />
        </div>
        <div class="form-group col col-md-3 required mb-4">
          <component-input
            type="phone"
            label="Контактный телефон"
            required
            v-model="repres.phone"
          />
        </div>
      </div>
    </div>

    <h5>Данные анкеты</h5>
    <div class="row">
      <div class="form-group col col-md-3">
        <label class="control-label">Дата заполнения</label>
        <date-component
          :disabled="isReadonly"
          v-model="item.pollCompleted.dateStart"
        />
        <!-- <div class="invalid-msg" v-if="v$.date.$error">Введите корректную дату</div> -->
      </div>
      <div class="form-group col col-md-3">
        <component-input
          type="timeLong"
          :disabled="isReadonly"
          v-model="item.pollCompleted.durationText"
          id="time"
          label="Продолжительность тестирования"
        />
        <div
          class="invalid-msg"
          v-if="v$.item.pollCompleted.durationText.$error"
        >
          Введите корректное время
        </div>
      </div>
      <div class="form-group col col-md-3 required">
        <component-input
          type="int"
          required
          :disabled="isReadonly"
          v-model="item.pollCompleted.numberOfPoints"
          id="numberOfPoints"
          label="Количество баллов"
        />
        <div
          class="invalid-msg"
          v-if="v$.item.pollCompleted.numberOfPoints.$error"
        >
          В группе риска при значении больше 2 баллов
        </div>
      </div>
    </div>
    <div class="row pb-2">
      <div class="form-group col col-md-3">
        <label class="control-label">Анкета</label>
        <file-upload
          width="100%"
          :entity="item"
          @deleteFile="removeFile('anketaFile')"
          prop-name="anketaFile"
          @uploaded="fileUploaded"
        />
      </div>
    </div>
    <div class="col col-md-12">
      <div class="form-check my-3 required">
        <component-input
          label="Согласие на обработку персональных данных"
          v-model="item.agreePersonalData"
          id="chAgreePersonalData"
          type="checkbox"
          scopeName="general"
          :required="true"
        />
      </div>
      <!-- <div class="form-group">
                            <label class='control-label'>Согласие на включение в Регистр</label>
                            <file-upload width="100%" :entity="item"
                                @deleteFile="removeFile('file')"
                                prop-name="file"
                                @uploaded="fileUploaded"/>
                            </div> -->
    </div>

    <div>
      <div class="float-right d-flex">
        <button-component
          v-if="!isReadonly"
          class="btn btn-primary mx-2"
          v-on:click="save" :disabled="isSaving"
          ><i class="fa fa-spinner fa-spin mr-2" v-if="isSaving"> </i>Сохранить</button-component
        >
        <button-component
          kind="secondary"
          type="button"
          class="btn btn-default"
          v-on:click="close"
          >Закрыть</button-component
        >
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../api/poll";
import Constants from "@/common/constants";
import { minValue, maxValue } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import DateComponent from "@/common/components/DateComponent";
import Inputmask from "inputmask";
import ButtonComponent from "@/common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput.vue";
import security from "@/common/mixins/security";
import Utils from "@/common/utils";
import FileUpload from "@/common/components/FileUpload";
import Select2Ajax from "../../../common/components/Select2Ajax";

const timeValidator = (value) =>
  value === null ||
  value === undefined ||
  value === "" ||
  new RegExp("^([0-9]{0,3}):[0-5][0-9]$", "g").test(value);

export default {
  name: "TmpPatientCard",
  props: {
    id: {
      type: Number,
    },
  },
  components: {
    Select2Ajax,
    ComponentInput,
    ButtonComponent,
    DateComponent,
    FileUpload,
  },
  mixins: [security],
  created() {
    // Api.getPoll((response) => {
    //   this.pollQuestionCount = response.data.items?.length;
    // });
    Utils.loadSelectOptions("district", this.districtList, {
      regionId: Constants.regionNizhnyNovgorodId,
    });
    Utils.loadSelectOptions("relationType", this.relationTypeList);
    this.checkPermission(Constants.TmpPatientEdit).then((response) => {
      if (response.data) this.loadCard();
      else Constants.alert.fire("Ошибка", "Недостаточно прав", "error");
    });
  },
  mounted() {
    // ... используем
    var im = new Inputmask("999:99");
    im.mask(document.getElementById("time"));
  },
  computed: {},
  data() {
    return {
      item: {
        tmpRepresentatives: [
          {
            relationTypeId: 0,
          },
        ],
        pollCompleted: {},
        addressDistrictId: 0,
      },
      isReadonly: false,
      districtList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      relationTypeList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      select2Settings: Constants.select2Settings,
      medOrgKey: 0,
      //pollQuestionCount: 100,
      isUpdateFromRMIS: false,
      isSaving: false
    };
  },
  methods: {
    loadCard() {
      if (this.id) {
        Api.find(this.id).then((response) => {
          this.item = response.data;
          this.item.pollCompleted.durationText =
            this.pad(Math.floor(this.item.pollCompleted.duration / 60), 3) +
            ":" +
            this.pad(this.item.pollCompleted.duration % 60, 2);
        });
      }
    },

    pad(num, size) {
      num = num.toString();
      while (num.length < size) num = "0" + num;
      return num;
    },

    save() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        Constants.alert.fire(
          "Ошибка",
          "Проверьте правильность заполнения полей",
          "error"
        );

        return;
      }

      if(this.id)
      {
        this.saveStep2();
        return;
      }
      Constants.alert
            .fire({
              title: "Подтверждение",
              text: "Вы действительно хотите добавить новую запись в Реестр группы риска?",
              confirmButtonText: "Да",
              cancelButtonText: "Нет",
              showCancelButton: true,
              icon: "warning",
            })
            .then((res) => {
              if (res.isConfirmed) {
                this.saveStep2();
              }
            });
    },
    saveStep2() {
      this.isSaving = true;
      this.item.pollCompleted.duration = 0;
      if (this.item.pollCompleted.durationText) {
        var parts = this.item.pollCompleted.durationText.split(":");
        this.item.pollCompleted.duration = parts[0] * 60 + parts[1] * 1;
      }

      Api.save(this.item).then((response) => {
                  Constants.alert.fire(
                    "Сохранение",
                    response.data.message,
                    response.data.success ? "success" : "error"
                  );
                  if (response.data.success) {
                    this.$emit("save");
                  }
                })
        .finally(() => {
          this.isSaving = false;
        });
    },
    close() {
      this.$emit("close");
    },
    removeFile(propName) {
      this.item[propName] = null;
      this.item[propName + "Id"] = null;
    },
    fileUploaded(e) {
      this.item[e.propName] = e.data;
      this.item[e.propName + "Id"] = e.data ? e.data.id : null;
    },
    updateFromRMIS() {
      this.isUpdateFromRMIS = true;
      Api.updatePatientMedOrgAttach(this.id).then((response) => {
        if (response.data.success) {
          Constants.alert.fire(
            "Обновление",
            "Данные успешно обновлены.",
            "success"
          );
          this.loadCard();
          this.medOrgKey++;
        } else {
          Constants.alert.fire("Обновление", response.data.message, "error");
        }
      })
      .finally(() => {
        this.isUpdateFromRMIS = false;
      });
    },
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      item: {
        pollCompleted: {
          durationText: { timeValidator },
          numberOfPoints: {
            minValue: minValue(3),
            maxValue: maxValue(100),
          },
        },
        agreePersonalData: { sameAs: (val) => val === true },
      },
    };
  },
};
</script>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.form-group.required .control-label:after {
  content: "*";
  color: red;
}
.form-check.required .control-label:after {
  content: "*";
  color: red;
}
.invalid-msg {
  color: red;
  font-size: 0.75rem;
}
.control-label {
  font-weight: 400 !important;
  color: $gray-dark;
  font-size: 16px;
}
</style>
